module.exports = __webpack_public_path__ + "img/img-box-3.358538ea.png";